module.exports = ".wrapper-page {\n  width: 70%;\n  margin: 100px auto; }\n\n.panel-primary {\n  border: 1px solid #ccc; }\n\n.panel-primary > .panel-heading {\n  border: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/login/login.component.scss
// module id = ./src/app/auth/login/login.component.scss
// module chunks = main